import { render, staticRenderFns } from "./RBProgram.vue?vue&type=template&id=38ea0e01&scoped=true&"
import script from "./RBProgram.vue?vue&type=script&lang=js&"
export * from "./RBProgram.vue?vue&type=script&lang=js&"
import style0 from "./RBProgram.vue?vue&type=style&index=0&id=38ea0e01&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ea0e01",
  null
  
)

export default component.exports